<template>
  <div class="plant-history-page" data-cy="plant-history-page">
    <AccessHandler :requiredRoleGroups="roleGroups" @accessChanged="(a: boolean) => (hasAccess = a)" />
    <MasterPage>
      <template v-if="hasAccess" v-slot:content>
        <PlantHistoryView :plantId="plantId" class="plant-history-page__view" />
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import MasterPage from "@/views/MasterPage.vue";
import GlobalFooter from "@/views/GlobalFooter.vue";
import AccessHandler from "@/shared/access/AccessHandler.vue";
import { RfrVisitsGroup, type RoleGroup } from "@/shared/access/RoleGroups";
import { ref, computed } from "vue";
import { useRoute } from "vue-router";
import PlantHistoryView from "./PlantHistoryView.vue";

const roleGroups = [RfrVisitsGroup] as RoleGroup[];

const hasAccess = ref<boolean>(false);
const route = useRoute();

const plantId = computed(() => {
  const id = route.params.plantId;
  return typeof id === "string" ? parseInt(id, 10) : 0;
});
</script>

<style scoped lang="scss">
.plant-history-page {
  .master-page {
    max-height: 1500px;

    @include media-breakpoint-up(md) {
      max-height: 1140px;
    }
  }

  &__view {
    margin: 24px auto;
    padding: 8px;
  }
}
</style>
